<template>
  <FlotoDropdownPicker
    :disabled="disabled"
    :options="options"
    :value="value"
    v-bind="$attrs"
    @change="handleChange"
    v-on="listeners"
  >
    <template v-slot:trigger="slotData">
      <slot name="trigger" v-bind="slotData" />
    </template>
    <template v-slot:menu-item="{ item, selectItem }">
      <div
        class="dropdown-item flex items-center justify-between"
        href="javascript:;"
        @click.stop="selectItem(item)"
      >
        <div class="flex items-center priority-option">
          <FlotoDot v-if="item.color" :bg="item.color" />
          <!-- <PriorityBars :system-name="item.systemName" :options="options" /> -->
          <span class="text-ellipsis" style="display: block">
            <MTooltip placement="topLeft">
              <template v-slot:trigger>
                {{ item.text || item.name || item.label }}
              </template>
              {{ item.text || item.name || item.label }}
            </MTooltip>
          </span>
        </div>
        <MIcon
          v-if="
            Array.isArray(value)
              ? value.indexOf(item.key) >= 0
              : value === item.key
          "
          name="check"
          class="text-primary"
        />
      </div>
    </template>
  </FlotoDropdownPicker>
</template>

<script>
import IsEqual from 'lodash/isEqual'
import { PriorityComputed } from '@state/modules/priority'
import FlotoDropdownPicker from '../_base-dropdown-picker.vue'
// import PriorityBars from '../priority-bars.vue'
import { keyEvents } from '@utils/keyevents'

export default {
  name: 'FlotoPriorityPicker',
  components: {
    FlotoDropdownPicker,
    // PriorityBars,
  },
  model: {
    event: 'change',
  },
  props: {
    mandatory: { type: Boolean, default: false },
    value: { type: [Number, Array, String], default: undefined },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  // extends: _baseDropdownPicker,
  computed: {
    ...PriorityComputed,
    options() {
      return this.priorityOptions
    },
    listeners() {
      const { change, ...listeners } = this.$listeners
      return listeners
    },
  },
  watch: {
    options: {
      handler(newValue, prevValue) {
        if (!IsEqual(newValue, prevValue)) {
          this.setDefaultValue()
        }
      },
    },
  },
  created() {
    this.setDefaultValue()
  },
  methods: {
    handleClickTagButton($event) {
      const buttonRef = this.$refs['tagTriggerRef']
      if ($event instanceof KeyboardEvent) {
        if ($event.key === keyEvents.SPACE) {
          $event.preventDefault()
          if (buttonRef) {
            buttonRef.$el.click()
          }
        }
      }
    },
    setDefaultValue() {
      if (!this.multiple && !this.value && this.mandatory) {
        let defaultValue = this.options.find((v) => v.default)
        if (!defaultValue) {
          defaultValue = this.options[0]
        }
        if (defaultValue) {
          this.$emit('change', defaultValue.key)
          this.$emit('set-default-value', defaultValue.key)
        }
      }
    },
    handleChange(value) {
      this.$emit('change', value)
    },
  },
}
</script>

<style lang="less" scoped>
.priority-option {
  display: flex;
  gap: 6px;
  align-items: center;
}
</style>
